<ngx-loading-bar #loading color="#3AA36B" includeSpinner="false" height="3px"></ngx-loading-bar>

<div id="supervisor-new">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" [formGroup]="newSupervisor">
      <div class="row">
        <div class="col">
          <label>
            <span>PRESTADOR DE SERVIÇO</span>

            <select formControlName="cdFornecedor">
              <option value="">Selecione o prestador de serviço</option>
              <option *ngFor="let provider of providersArr;" [value]="provider.cdFornecedor">{{ provider.nmRazaoSocial }}</option>
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOGIN</span>

            <input type="text" placeholder="Login" formControlName="cdsLogin">
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>NOME</span>

            <input type="text" placeholder="Nome completo" formControlName="nmOperador">
          </label>
        </div>

        <div class="col">
          <label>
            <span>TELEFONE</span>

            <input type="text" placeholder="Telefone/celular" formControlName="nrTelefone" (keyup)="maskPhone($event.target.value);" mask="{{ phone }}">
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>E-MAIL</span>

            <input type="text" placeholder="E-mail" formControlName="dsEmail">
          </label>
        </div>

        <div class="col">
          <label>
            <span>SENHA</span>

            <input type="password" placeholder="Senha" formControlName="dsSenha">
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <button (click)="addNewServiceProvider();">CADASTRAR SUPERVISOR</button>
        </div>
      </div>
    </div>
  </app-new>
</div>
